import { InjectionToken } from '@angular/core';
import { IErrorHandlerOptions, ILoggerService, INotificationService } from '@orthofi/ngx-error-handler/error-handler-interfaces.service';

export const SHOW_ERROR_DETAILS = new InjectionToken<boolean>('SHOW_ERROR_DETAILS');
export const LOGGER_SERVICE = new InjectionToken<ILoggerService>('LOGGER_SERVICE');
export const NOTIFICATION_SERVICE = new InjectionToken<INotificationService>('NOTIFICATION_SERVICE');
export const LOGIN_URL = new InjectionToken<string>('LOGIN_URL');
export const ERROR_HANDLER_OPTIONS = new InjectionToken<IErrorHandlerOptions>('ERROR_HANDLER_OPTIONS');
